export default{
    setTickets(state, payload){
        state.tickets = payload;
    },

    setPages(state, payload){
        state.pages = payload;
    }
}